import $ from "jquery";

const TABLET_RESOLUTION = 1019;

const isDesktop = () => {
    return window.outerWidth > TABLET_RESOLUTION
};

const toggleClass = (target, mobileOnly) => {
    if (mobileOnly && isDesktop()) {
        return;
    }

    const toggleBtn = $(target);
    const toggledDivId = $(target).data('toggled');
    const parentDivId = $(target).data('parent');
    const toggledDiv = $(toggledDivId);
    const parentDiv = $(parentDivId);
    const transitionDuration = 250;

    toggledDiv.stop().slideToggle(transitionDuration);
    toggleBtn.toggleClass('toggle-div--active');
    parentDiv.toggleClass('plan-faq__item--active');
}

export const toggleDiv = () => {
    $(document).on('click', '.toggle-div', function () {
        toggleClass(this, false);
    });

    $(document).on('click', '.toggle-div-mobile', function () {
        toggleClass(this, true);
    });
};
